import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export function ModalCertezaAprovarLote({
  show,
  handleClose,
  onConfirm,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Aprovar lote"
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={onConfirm}
      confirmButtonText="Aprovar"
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>
        Deseja aprovar o lote selecionado? Após a confirmação, o lote será
        exibido na aba Aprovados para pagamento.
      </ModalBody>
    </ModalCustom>
  );
}
